import BaseAssetPickerView from 'backbone/platform/views/assets/base_asset_picker_view.js'
import MediaLibraryAssetsLayoutView from 'backbone/platform/views/assets/media_library_assets_layout_view.js'

export default class SingleAssetPickerView extends BaseAssetPickerView
  _renderActions: ->
    super
    @actionsView.render(hideChoose: true)

  _attachTemplate: ->
    @$el.html @template
      activeTab: "upload"
      showChooseTab: @options.mediaLibraryAccess
      modalHeaderTitle: @options.modalHeaderTitle
      modalAttachText: @options.modalAttachText
      brandProfileId: @options.brandProfileId
      inputId: @options.inputId || "asset_uploader_input" # direct or multipart upload

  _renderCollection: ->
    @assetsCollectionView = new MediaLibraryAssetsLayoutView
      el: @$(".modal-assets-manager")
      brandProfileId: @options.brandProfileId
      collection: @options.mediaLibraryAssets
      mediaLibraryAccess: @options.mediaLibraryAccess
      clickCallback: @assetsPickedCallback
    @subviews.push(@assetsCollectionView)
    @$("#modal-tab1").append(@assetsCollectionView.render().$el)



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/single_asset_picker_view.js.coffee